import { createSelector } from "reselect";

const getGnomadGenesData = (state) => {
  return __IS_COMPONENTS_PORTAL__
    ? state?.variantResult?.genes?.[state.selectedGeneIndexClinical]
        ?.gnomad_genes
    : state?.variantResult?.gnomad_genes;
};

const getLofZScore = createSelector(getGnomadGenesData, (result) => {
  if (result && result.items && result.items[0]) {
    return result.items[0].lof_z;
  }
  return null;
});

const getMissenseScore = createSelector(getGnomadGenesData, (result) => {
  if (result && result.items && result.items[0]) {
    return result.items[0].mis_z;
  }
  return null;
});

export { getGnomadGenesData, getLofZScore, getMissenseScore };
